import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'roleName',
      type: 'input',
      label: '角色名',
      placeholder: '请输入角色名，自动添加ROLE_',
      rules: { required: true, message: '角色名是必传的', trigger: 'blur' }
    },
    {
      field: 'displayName',
      type: 'input',
      label: '显示名',
      placeholder: '请输入显示名',
      rules: { required: true, message: '显示名是必传的', trigger: 'blur' }
    },
    {
      field: 'sort',
      type: 'input',
      label: '排序',
      placeholder: '请输入排序值 0-100 之间',
      rules: { required: true, message: '排序必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
